export default "__VITE_ASSET__DDDemE13__"